import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { isPreviewMode } from "../lib/content";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, ready } = useAuth();
  const preview = isPreviewMode();
  if (!ready) {
    return (
      <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-muted)" }}>
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  // In preview mode, let admin freely visit seller pages (without the usual admin→/admin redirect)
  if (!adminOnly && user.role === "admin" && !preview) return <Navigate to="/admin" replace />;
  return children;
}
